import { useEffect } from "react";

import { createFileRoute, useNavigate } from "@tanstack/react-router";

import { HOME_ROUTE } from "@/utils/constants";

export const Route = createFileRoute("/")({
  component: HomeComponent,
});

function HomeComponent() {
  const navigate = useNavigate();

  useEffect(() => {
    // Type-safe navigation to dashboard
    navigate({ to: HOME_ROUTE, replace: true });
  }, [navigate]);

  return null;
}
